// badge images
import palBadgeImageEn from 'Assets/badging/Badge_Pal_EN.png';
import buddyBadgeImageEn from 'Assets/badging/Badge_Buddy_EN.png';
import rangerBadgeImageEn from 'Assets/badging/Badge_Ranger_EN.png';
import titanBadgeImageEn from 'Assets/badging/Badge_Titan_EN.png';
import guruBadgeImageEn from 'Assets/badging/Badge_Guru_EN.png';
import wizardBadgeImageEn from 'Assets/badging/Badge_Wizard_EN.png';

import palBadgeImageEs from 'Assets/badging/Badge_Pal_ES.png';
import buddyBadgeImageEs from 'Assets/badging/Badge_Buddy_ES.png';
import rangerBadgeImageEs from 'Assets/badging/Badge_Ranger_ES.png';
import titanBadgeImageEs from 'Assets/badging/Badge_Titan_ES.png';
import guruBadgeImageEs from 'Assets/badging/Badge_Guru_ES.png';
import wizardBadgeImageEs from 'Assets/badging/Badge_Wizard_ES.png';

export const REWARD_LEVEL = {
  PAL: "PAL",
  BUDDY: "BUDDY",
  RANGER: "RANGER",
  TITAN: "TITAN",
  GURU: "GURU",
  WIZARD: "WIZARD",
};

export const BADGE_TYPE = {
  NUM_SESSIONS: "NUM_SESSIONS",
  NUM_MINUTES: "NUM_MINUTES",
  NEW_WCPM_HIGH: "NEW_WCPM_HIGH",
  SKILLS_SCAFFOLD_GRADUATION: "SKILLS_SCAFFOLD_GRADUATION",
  NEW_HIGH: "NEW_HIGH",
  CUSTOM: "CUSTOM",
};

// The number of sessions that represents a badge level
export const REWARD_LEVEL_TO_NUM_SESSIONS = {
  [REWARD_LEVEL.PAL]: 5,
  [REWARD_LEVEL.BUDDY]: 10,
  [REWARD_LEVEL.RANGER]: 20,
  [REWARD_LEVEL.TITAN]: 50,
  [REWARD_LEVEL.GURU]: 75,
  [REWARD_LEVEL.WIZARD]: 100
}


export const BADGE_COORDINATE = {
  "NUM_SESSIONS": {
    "EN_US": {
      'PAL': {left: "30.4%", bottom: "17.8%"},
      "BUDDY": {left: "31.8%", bottom: "25.8%"},
      "RANGER": {left: "35.7%", bottom: "27.9%"},
      "TITAN": {left: "40%", bottom: "29%"},
      "GURU": {left: "44%", bottom: "24.5%"},
      "WIZARD": {left: "46%", bottom: "16.5%"},
    },
    "ES_MX": {
      'PAL': {left: "27.8%", bottom: "19.5%"},
      "BUDDY": {left: "30.0%", bottom: "29.6%"},
      "RANGER": {left: "35.8%", bottom: "33.6%"},
      "TITAN": {left: "41.5%", bottom: "34.0%"},
      "GURU": {left: "47%", bottom: "28.8%"},
      "WIZARD": {left: "50%", bottom: "17.5%"},
    }
  },
  "NUM_MINUTES": {
    "EN_US": {
      "BUDDY": {left: "21.5%", bottom: "53.9%"},
      "GURU": {left: "58.3%", bottom: "49.9%"},
    },
    "ES_MX": {
      "BUDDY": {left: "19.6%", bottom: "59.9%"},
      "GURU": {left: "60.3%", bottom: "44.9%"},
    }
  },
  "NEW_WCPM_HIGH": {
    "EN_US": {
      'PAL': {left: "25.3%", bottom: "21.6%"},
      "BUDDY": {left: "28.0%", bottom: "33.5%"},
      "RANGER": {left: "34.2%", bottom: "39.4%"},
      "TITAN": {left: "42%", bottom: "41%"},
      "GURU": {left: "50.3%", bottom: "33.9%"},
      "WIZARD": {left: "53.5%", bottom: "19.5%"}
    },
    "ES_MX": {
      'PAL': {left: "22.5%", bottom: "23.6%"},
      "BUDDY": {left: "26.0%", bottom: "37.8%"},
      "RANGER": {left: "35.2%", bottom: "44.1%"},
      "TITAN": {left: "43.4%", bottom: "46.2%"},
      "GURU": {left: "53.3%", bottom: "35.9%"},
      "WIZARD": {left: "57.5%", bottom: "19.1%"}
    }
  },
  "SKILLS_SCAFFOLD_GRADUATION": {
    "EN_US": {
      'PAL': {left: "20.0%", bottom: "22.6%"},
      "GURU": {left: "57.4%", bottom: "40.7%"},
    },
    "ES_MX": {
      'PAL': {left: "19.6%", bottom: "28.4%"},
      "GURU": {left: "55.4%", bottom: "45.2%"},
    }
  },
  "NEW_HIGH": {
    "EN_US": {
      "RANGER": {left: "30.1%", bottom: "67.6%"},
      "GURU": {left: "62.1%", bottom: "55.4%"},
      "WIZARD": {left: "66.4%", bottom: "24.3%"},
    },
    "ES_MX": {
      "RANGER": {left: "33.1%", bottom: "68.8%"},
      "GURU": {left: "64.6%", bottom: "50.4%"},
      "WIZARD": {left: "69.4%", bottom: "19.3%"},
    }
  },
  "CUSTOM": {
    "EN_US": {
      'PAL': {left: "2.5%", bottom: "34.1%"},
      "BUDDY": {left: "3.0%", bottom: "75%"},
      "RANGER": {left: "28.3%", bottom:"77%"},
      "TITAN": {left: "46.5%", bottom: "70%"},
      "GURU": {left: "66%", bottom: "60%"},
      "WIZARD": {left: "71.3%", bottom: "26.5%"}
    },
    "ES_MX": {
      'PAL': {left: "1.6%", bottom: "40.1%"},
      "BUDDY": {left: "4.7%", bottom: "81.7%"},
      "RANGER": {left: "31.3%", bottom:"78%"},
      "TITAN": {left: "50%", bottom: "69%"},
      "GURU": {left: "69%", bottom: "55%"},
      "WIZARD": {left: "73.3%", bottom: "20.5%"}
    }
  },
};

export const BADGE_IMAGE = {
  "EN_US": {
    "PAL": palBadgeImageEn,
    "BUDDY": buddyBadgeImageEn,
    "RANGER": rangerBadgeImageEn,
    "TITAN": titanBadgeImageEn,
    "GURU": guruBadgeImageEn,
    "WIZARD": wizardBadgeImageEn
  },
  "ES_MX": {
    "PAL": palBadgeImageEs,
    "BUDDY": buddyBadgeImageEs,
    "RANGER": rangerBadgeImageEs,
    "TITAN": titanBadgeImageEs,
    "GURU": guruBadgeImageEs,
    "WIZARD": wizardBadgeImageEs
  }
};

export const DANCE_TITLES = {
  CHICKEN: "The Funky Chicken",
  RENEGADE: "The Renegade Dance",
  FLOSS: "The Floss Dance",
};

export const BADGE_LEVELS = [
  "PAL",
  "BUDDY",
  "RANGER",
  "TITAN",
  "GURU",
  "WIZARD"
];

export const REWARD_LEVEL_OPTIONS = {
  "EN_US": [
    {value: REWARD_LEVEL.PAL, label: 'Pal Level 1 (Pink Panda)'},
    {value: REWARD_LEVEL.BUDDY, label: 'Buddy Level 2 (Yellow Bear)'},
    {value: REWARD_LEVEL.RANGER, label: 'Ranger Level 3 (Red Rabbit)'},
    {value: REWARD_LEVEL.TITAN, label: 'Titan Level 4 (Teal Tiger)'},
    {value: REWARD_LEVEL.GURU, label: 'Guru Level 5 (Green Gorilla)'},
    {value: REWARD_LEVEL.WIZARD, label: 'Wizard Level 6 (Violet Unicorn)'},
  ],
  "ES_MX": [
    {value: REWARD_LEVEL.PAL, label: 'Nivel 1: Camarada (quetzal rosa)'},
    {value: REWARD_LEVEL.BUDDY, label: 'Nivel 2: Compañero (perro xolo amarillo)'},
    {value: REWARD_LEVEL.RANGER, label: 'Nivel 3: Guardia (serpiente falsa coral roja)'},
    {value: REWARD_LEVEL.TITAN, label: 'Nivel 4: Titán (jaguar verde azulado)'},
    {value: REWARD_LEVEL.GURU, label: 'Nivel 5: Gurú (burro verde)'},
    {value: REWARD_LEVEL.WIZARD, label: 'Nivel 6: Mago (águila dorada)'},
  ]
}

export const LOCALE_OPTIONS = [
  {value: "EN_US", label: 'English'},
  {value: "ES_MX", label: 'Spanish'},
]

export const BACKGROUND_WIDTH = 1920;
export const BACKGROUND_HEIGHT = 1080;